var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartBomNoItems(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 200,
    viewBox: "0 0 175 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_206_83613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8027 1.31543V12.4496",
    stroke: "#313131",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.21875 9.47266L16.1253 17.3486",
    stroke: "#313131",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.31641 27.0459H12.4938",
    stroke: "#313131",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3674 199.664C136.22 199.664 175.012 161.022 175.012 113.355C175.012 65.6878 136.22 27.0459 88.3674 27.0459C40.5148 27.0459 1.72266 65.6878 1.72266 113.355C1.72266 161.022 40.5148 199.664 88.3674 199.664Z",
    fill: "#86ABF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0207 23.2583C26.7834 23.2583 21.7305 28.2917 21.7305 34.5048V168.081C37.6225 187.226 61.6466 199.438 88.5356 199.438C115.425 199.438 139.426 187.248 155.318 168.114V46.2569L133.584 23.2471H33.0207V23.2583Z",
    fill: "white",
    stroke: "#313131",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.318 46.2573H133.584V23.3037L155.318 46.2573Z",
    fill: "white",
    stroke: "#313131",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8548 91.5305C63.8233 91.3752 65.2596 89.2435 65.0629 86.7692C64.8661 84.2949 63.1109 82.415 61.1424 82.5704C59.1739 82.7257 57.7376 84.8574 57.9343 87.3316C58.1311 89.8059 59.8863 91.6858 61.8548 91.5305Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.834 91.5246C118.8 91.7068 120.581 89.8511 120.812 87.3798C121.042 84.9084 119.636 82.7573 117.669 82.5751C115.703 82.3928 113.922 84.2485 113.691 86.7199C113.461 89.1912 114.867 91.3424 116.834 91.5246Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9961 77.3887C52.9961 77.3887 61.5004 79.4897 65.0758 72.6924",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.373 98.7793C82.6814 103.296 93.2949 106.7 97.3891 98.7793",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.662 77.3887C124.662 77.3887 116.157 79.4897 112.582 72.6924",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_206_83613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.9796 97.227C65.9755 99.8604 60.6662 102.271 56.3334 100.936C52.0006 99.6008 48.5894 94.7419 50.5839 92.6154C51.8493 91.2554 54.1051 92.8997 58.4379 94.235C62.7706 95.5703 67.9837 94.5936 66.9796 97.227Z",
    fill: "#F5889D",
    fillOpacity: 0.19
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_206_83613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.958 97.227C112.885 99.8604 117.786 102.271 121.785 100.936C125.785 99.6008 128.933 94.7419 127.092 92.6154C125.924 91.2554 123.842 92.8997 119.842 94.235C115.843 95.5703 111.031 94.5936 111.958 97.227Z",
    fill: "#F5889D",
    fillOpacity: 0.19
  })), /*#__PURE__*/React.createElement("rect", {
    x: 37.4082,
    y: 132.769,
    width: 77.8246,
    height: 5.61763,
    rx: 2,
    fill: "#1181E9",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.4082,
    y: 146.251,
    width: 99.2546,
    height: 5.61763,
    rx: 2,
    fill: "#1181E9",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.4082,
    y: 159.732,
    width: 62.0341,
    height: 5.61763,
    rx: 2,
    fill: "#1181E9",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_206_83613",
    x: 46,
    y: 88.1055,
    width: 25.1055,
    height: 17.2109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_206_83613"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_206_83613",
    x: 107.842,
    y: 88.1055,
    width: 23.7891,
    height: 17.2109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_206_83613"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_206_83613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartBomNoItems);
export default __webpack_public_path__ + "static/media/partBomNoItems.fdd6ee5577414209d9402d7ae589a4a9.svg";
export { ForwardRef as ReactComponent };